import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { closeDialog } from '../store/legacy/actions/dialogActions';

function ReduxResponsiveDialog(props) {
  const { open, title, body, message, buttons = [], fullScreen, closeDialog, classes } = props;
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={closeDialog}
      aria-labelledby={title}
      classes={{ root: classes.root }}>
      <Grid container className={classes.container}>
        {body || (
          <React.Fragment>
            <DialogTitle id={title}>{title}</DialogTitle>
            <DialogContent classes={{ root: classes.contentRoot }}>
              <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
              {buttons.map((button, id) => (
                <Button key={id} color={button.color} onClick={button.onClick || closeDialog}>
                  {button.text}
                </Button>
              ))}
            </DialogActions>
          </React.Fragment>
        )}

        <IconButton
          onClick={closeDialog}
          style={{
            position: 'absolute',
            top: 5,
            right: 5,
            width: 40,
            height: 40,
          }}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  const { open, onClose, message, body, title, buttons } = state.dialog;
  return {
    open,
    onClose,
    message,
    body,
    title,
    buttons,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeDialog: () => dispatch(closeDialog()),
});

const style = (theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
    minHeight: '30vh',
  },
  contentRoot: {
    width: '100%',
    overflowY: 'initial',
  },
});

export default withMobileDialog()(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(ReduxResponsiveDialog))
);
